import {NEWS_DETAIL} from '../constants/NewsConst';

const initialState = {};

const newsDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEWS_DETAIL:
      return {
        ...state,
        newsDetail: action.payload,
      };
    default:
      return state;
  }
};
export default newsDetailReducer;
